import { render, staticRenderFns } from "./RoleIdColumn.vue?vue&type=template&id=3c87e95a&"
import script from "./RoleIdColumn.vue?vue&type=script&lang=js&"
export * from "./RoleIdColumn.vue?vue&type=script&lang=js&"
import style0 from "./RoleIdColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c87e95a')) {
      api.createRecord('3c87e95a', component.options)
    } else {
      api.reload('3c87e95a', component.options)
    }
    module.hot.accept("./RoleIdColumn.vue?vue&type=template&id=3c87e95a&", function () {
      api.rerender('3c87e95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/RoleIdColumn.vue"
export default component.exports